import { toSnakeCase } from '../../../common/helpers/stringHelpers'
import { getItemBrand } from './helpers/listingsHelpers'

const getTripEndCityItems = (airportCodeParams) => ({
  item_category2: toSnakeCase(airportCodeParams[0] + '_' + airportCodeParams[1], { lowerCase: true }),
  /*dest_city_name*/
})

const getItemID = ({ code, stops = 0, timeFrame, isExpressDeal }) => ({
  item_id: toSnakeCase((isExpressDeal ? 'sopq' : code) + ('_' + stops + '_' + timeFrame), {
    lowerCase: true,
  }),
})

// type doesn't exist anymore
// const getSliceItems = (type) => ({
//   slice: type,
// })

const getExpressDealItems = (isExpressDeal) => ({
  item_category4: isExpressDeal ? 'sopq' : 'rtl',
  item_list_id: isExpressDeal ? 'sopq' : 'retail',
})

const getDealsItems = (isUserSignedIn) => ({
  item_category5: isUserSignedIn ? 'vip deal' : null,
})

const getPurchaseWindowItems = (ap, los, tripType) => {
  if (!Number.isInteger(los) || !Number.isInteger(ap) || !tripType) {
    return {
      item_category3: null,
    }
  }
  let apStr
  let losStr = tripType === 'OW' ? '0' : ''

  const apNum = Number(ap)
  const losNum = Number(los)

  if (apNum >= 29) apStr = '29+'
  else if (apNum >= 15) apStr = '15-28'
  else if (apNum >= 8) apStr = '8-14'
  else if (apNum >= 2) apStr = '2-7'
  else if (apNum < 0) apStr = '0'
  else apStr = ap

  if (losStr === '') {
    if (losNum >= 11) losStr = '11+'
    else if (losNum >= 4) losStr = '4-10'
    else losStr = los
  }
  return {
    item_category3: `${apStr}_${losStr}`,
  }
}

const getEcommerceNode = ({
  ap,
  los,
  segments,
  isExpressDeal = false,
  affiliation,
  airportCodeParams,
  isCheapest,
  tripType,
  stops,
  timeFrame,
  allBadgesString,
  isUserSignedIn,
}) => {
  const cheapestValue = isCheapest ? 'cheapest' : null
  const itemCategoryValue = allBadgesString
    ? allBadgesString.replace('package-exclusive-flight-deal', 'package_exclusive')
    : cheapestValue

  return {
    item_name: 'air',
    item_category: itemCategoryValue,
    item_brand: getItemBrand(segments),
    ...(airportCodeParams && getTripEndCityItems(airportCodeParams)),
    ...getItemID({
      code: segments?.[0]?.marketingAirline || null,
      stops: stops?.toString?.(),
      timeFrame,
      isExpressDeal,
    }),
    ...getPurchaseWindowItems(ap, los, tripType),
    ...getExpressDealItems(isExpressDeal),
    ...getDealsItems(isUserSignedIn),
    ...(affiliation && {
      affiliation,
    }),
  }
}

export { getEcommerceNode, getItemID, getPurchaseWindowItems, getTripEndCityItems }
